import React, { PropsWithChildren } from 'react';
import ButtonBase from './ButtonBase';

interface ButtonProps {
  onClick: CallableFunction;
  disabled?: boolean;
  className?: string;
  outline?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

const Button = ({
  children,
  onClick = () => {},
  disabled = false,
  className,
  outline = false,
  type = 'button',

}: PropsWithChildren<ButtonProps>) => {

  const handleClick = () => {
    onClick()
  }

  return (
    <ButtonBase
      type={type}
      onClick={handleClick}
      disabled={disabled}
      className={`
        ${className}
        ${outline ? 'ring-gray-400 hover:ring-gray-300' : 'ring-gray-300 hover:ring-gray-400 hover:bg-gray-50 '}
    `}>
      {children}
    </ButtonBase>
  )
}

export default Button;